import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=72741186&"
import script from "./partners.vue?vue&type=script&lang=js&"
export * from "./partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72741186')) {
      api.createRecord('72741186', component.options)
    } else {
      api.reload('72741186', component.options)
    }
    module.hot.accept("./partners.vue?vue&type=template&id=72741186&", function () {
      api.rerender('72741186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/base/vacancies/partners.vue"
export default component.exports